import {NextRequest} from "next/server";

const IPFS_GATEWAY = "https://ipfs.io/ipfs/";

const detectIPFSMedia = (data: string) => {
    return data.startsWith('ipfs://') || data.includes('/ipfs/');
}

export function toGatewayUrl(uri?: string): string | undefined {
    // console.log("original uri: " + uri);

    if (!uri) return undefined;

    // ipfs://CID or ipfs://CID/path/file.mp4
    if (uri.startsWith("ipfs://")) {
        return IPFS_GATEWAY + uri.slice("ipfs://".length);
    }

    // already an https gateway url -> convert to our preferred gateway
    if (uri.includes("/ipfs/")) {
        const id = uri.split("/ipfs/")[1];
        return IPFS_GATEWAY + id;
    }

    return uri; // normal https urls
}

const chainIdFromCaip = (caip: string) => {
    const chainPart = caip.split("/")[0];
    const [, idStr] = chainPart.split(":");
    const id = Number(idStr);
    if (!Number.isFinite(id)) throw new Error("Bad CAIP: " + caip);
    return id;
}

const getTokenFromAuthHeader = (request: NextRequest): (string | undefined) => request.headers.get('Autentication')?.substring(7);

export {
    detectIPFSMedia,
    chainIdFromCaip,
    getTokenFromAuthHeader
}